import { InputLabel, styled } from '@mui/material';

export const Label = styled(InputLabel)({
    fontSize: '18px',
    fontWeight: 400,
    color: '#131313',
});

// TODO: Move this to other file
export const FORM_IDS = {
    EDIT_PRICE_GROUP_DATA: 1,
    ADD_UNIT: 2,
    ADD_RANGE: 3,
    ADD_ORIGIN: 4,
    EDIT_UNIT: 5,
    EDIT_RANGES: 6,
    DELETE_UNIT: 7,
    DELETE_RANGE: 8,
    DELETE_ORIGIN: 9,
    CHANGE_LIST: 10,
};
